import { render, staticRenderFns } from "./statusBadges.vue?vue&type=template&id=4a19af37&"
import script from "./statusBadges.vue?vue&type=script&lang=ts&"
export * from "./statusBadges.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports